import React from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Config from "conFig.js";
import { NumericFormat } from "react-number-format";
import { Error, Success } from "../../../assets/jss/util/messageUtil";

export default function Themtuyencodinh() {
  const [thututoanquoc, setThututoanquoc] = React.useState(0);
  const [tinh_a, setTinh_a] = React.useState([]);
  const [tinh_a_id, setTinh_a_id] = React.useState(0);
  const [tinh_b, setTinh_b] = React.useState([]);
  const [tinh_b_id, setTinh_b_id] = React.useState(0);
  const [matuyen, setMatuyen] = React.useState("");
  const [benxe_a, setBenxe_a] = React.useState("");
  const [benxe_b, setBenxe_b] = React.useState("");
  const [hanhtrinh, setHanhtrinh] = React.useState("");
  const [culytuyen, setCulytuyen] = React.useState(0);
  const [luuluong, setLuuluong] = React.useState(0);
  const [dangkhaithac, setDangkhaithac] = React.useState(0);
  const [luuluongconlai, setLuuluongconlai] = React.useState(0);
  const [thoigiangiancach, setThoigiangiancach] = React.useState(0);
  const [phanloaituyen, setPhanloaituyen] = React.useState("");
  const [nguontuyen, setNguontuyen] = React.useState("");
  const [ghichu, setGhichu] = React.useState("");
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [alertValidate, setAlertValidate] = React.useState(false);
  const [messageValidate, setMessageValidate] = React.useState("");
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const gettinhthanh = () => {
    var url = Config.backend + "/api/Diaphuong/gettinh?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setTinh_a(data);
        setTinh_b(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const inserttuyenxe = () => {
    let mess = validateThem();
    if (mess === Success.SC0001) {
      var url = Config.backend + "/api/Phuongtien/themtuyencodinh";
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          thututoanquoc: thututoanquoc,
          matuyen: matuyen,
          tinh_a_id: tinh_a_id,
          tinh_b_id: tinh_b_id,
          benxe_a: benxe_a,
          benxe_b: benxe_b,
          hanhtrinh: hanhtrinh,
          culytuyen: culytuyen,
          luuluong: luuluong,
          dangkhaithac: dangkhaithac,
          luuluongconlai: luuluongconlai,
          thoigiangiancach: thoigiangiancach,
          phanloaituyen: phanloaituyen,
          nguontuyen: nguontuyen,
          ghichu: ghichu,
          username: username,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data === 1) {
            showNotification();
          } else showNotification1();
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const showNotificationValidate = () => {
    setAlertValidate(true);
    setTimeout(function () {
      setAlertValidate(false);
    }, 6000);
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  const validateThem = () => {
    // Kiem tra cac truong bat buoc nhap
    if (!tinh_a_id || tinh_a_id === 0) {
      return Error.ER0002;
    }
    if (!tinh_b_id || tinh_b_id === 0) {
      return Error.ER0003;
    }
    return Success.SC0001;
  };
  React.useEffect(() => {
    gettinhthanh();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <NumericFormat
                label="Thứ tự toàn quốc"
                variant="outlined"
                size="small"
                value={thututoanquoc}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setThututoanquoc(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Mã tuyến"
                variant="outlined"
                value={matuyen}
                size="small"
                onChange={(event) => {
                  setMatuyen(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                options={tinh_a}
                getOptionLabel={(option) => option.ten}
                onChange={(event, value) => {
                  setTinh_a_id(value.id);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Chọn tỉnh đầu"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "37px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                options={tinh_b}
                getOptionLabel={(option) => option.ten}
                onChange={(event, value) => {
                  setTinh_b_id(value.id);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Chọn tỉnh cuối"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "37px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Bến đầu"
                variant="outlined"
                value={benxe_a}
                size="small"
                onChange={(event) => {
                  setBenxe_a(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Bến cuối"
                variant="outlined"
                value={benxe_b}
                size="small"
                onChange={(event) => {
                  setBenxe_b(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Hành trình"
                variant="outlined"
                value={hanhtrinh}
                size="small"
                onChange={(event) => {
                  setHanhtrinh(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <NumericFormat
                label="Cự ly tuyến"
                variant="outlined"
                size="small"
                value={culytuyen}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setCulytuyen(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <NumericFormat
                label="Lưu lượng"
                variant="outlined"
                size="small"
                value={luuluong}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setLuuluong(value);
                  setLuuluongconlai(value - dangkhaithac);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <NumericFormat
                label="Đang khai thác"
                variant="outlined"
                size="small"
                value={dangkhaithac}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setDangkhaithac(value);
                  setLuuluongconlai(luuluong - value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <NumericFormat
                label="Lưu lượng còn lại"
                variant="outlined"
                size="small"
                value={luuluongconlai}
                disabled
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <NumericFormat
                label="Thời gian giãn cách"
                variant="outlined"
                size="small"
                value={thoigiangiancach}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setThoigiangiancach(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Phân loại tuyến"
                variant="outlined"
                value={phanloaituyen}
                size="small"
                onChange={(event) => {
                  setPhanloaituyen(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Nguồn tuyến"
                variant="outlined"
                value={nguontuyen}
                size="small"
                onChange={(event) => {
                  setNguontuyen(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ marginTop: 15 }}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                label="Ghi chú"
                variant="outlined"
                value={ghichu}
                size="small"
                onChange={(event) => {
                  setGhichu(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "20px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          onClick={inserttuyenxe}
        >
          Thêm
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Thêm thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình thêm"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alertValidate}
            closeNotification={() => setAlertValidate(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
}
